<template>
  <div class="loading">
    <div class="ring">
      Loading
      <span />
    </div>
    <span class="text_loader">
      Traduzindo as informações, isso pode demorar alguns segundos . . .
    </span>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.loading {
  width: 100%;
  transition: 1.2s;
  margin-top: 0px;
  background: rgba(179, 179, 179, 0.089);
  -webkit-backdrop-filter: blur(9px);
  backdrop-filter: blur(9px);
  z-index: 3;
  height: 100vh;
  position: fixed;
}

.ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 150px;
  background: transparent;
  border: 3px solid rgb(146, 146, 146);
  border-radius: 50%;
  text-align: center;
  line-height: 150px;
  font-family: sans-serif;
  font-size: 20px;
  color: var(--green);
  letter-spacing: 4px;
  text-transform: uppercase;
}

.ring::before {
  content: "";
  position: absolute;
  top: -3px;
  left: -3px;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top: 3px solid var(--green);
  border-right: 3px solid var(--green);
  border-radius: 50%;
  animation: animateCircle 2s linear infinite;
}

.ring span {
  display: block;
  position: absolute;
  top: calc(50% - 2px);
  left: 50%;
  width: 50%;
  height: 4px;
  background: transparent;
  transform-origin: left;
  animation: animate 2s linear infinite;
}
.ring span::before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--green);
  top: -6px;
  right: -8px;
  box-shadow: 0 0 20px var(--green);
}

.text_loader {
  position: absolute;
  left: 32%;
  top: 65%;
  font-style: italic;
}

@keyframes animateCircle {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes animate {
  0% {
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(405deg);
  }
}
</style>
